import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'floor',
  standalone: false,
})
export class SgFloorPipe implements PipeTransform {
  transform(value: number | null | undefined): number | null {
    return value ? Math.floor(value) : 0;
  }
}
